module.exports = __webpack_public_path__ + "static/media/mountain2.af2684c0.jpg";